import { Route, Routes } from "react-router-dom";

import {BankAccountPayoutLink } from "../../pages";

export const BankPayoutLinkLayout = () =>{
  return (
    <Routes>
    <Route path="/" element={<BankAccountPayoutLink/>} />
  </Routes>
  )
}

    
  
